<section class="requirement-intake-layout uls">
  <section class="left-panel">
    <article class="ul-card requirement-intake-panel requirement-list-panel">
      @if (isMobileMode()) {
        <button
          type="button"
          class="header-button"
          [aria-label]="!isCollapsed() ? 'Expand description' : 'Collapse description'"
          (click)="toggle()"
        >
          <div class="card-header">
            <div class="headline">
              <h2 translate="model.productRevision.references.intakes"></h2>
            </div>
            <ul-chip [additionalClasses]="{ 'no-color': true }">
              {{ groupedRequirements().length + ' sections' }}
            </ul-chip>
            <div class="toggle">
              <svg
                class="tree-container-chevron"
                [class.open]="!isCollapsed()"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
              >
                <path
                  d="M6 9l6 6 6-6"
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </button>
      } @else {
        <div class="card-header">
          <div class="headline">
            <h2 translate="model.productRevision.references.intakes"></h2>
            <p translate="model.productRevision.references.description"></p>
          </div>
          <ul-chip [additionalClasses]="{ 'no-color': true }">
            {{ groupedRequirements().length + ' sections' }}
          </ul-chip>
        </div>
      }
      <div
        class="tree-container"
        [class.expanded]="!isCollapsed()"
        [class.scroll-shadow-top]="showTreeTopShadow()"
        [class.scroll-shadow-bottom]="showTreeBottomFade()"
      >
        <div class="tree-container-inner" #treeScrollContainer (scroll)="onTreeScroll()">
          @if (isMobileMode()) {
            <p translate="model.productRevision.references.description"></p>
          }
          <comp-requirement-tree
            [revisionId]="revisionId()"
            [selectedRequirementId]="selectedRequirement()?.id"
            [groupedRequirements]="groupedRequirements()"
            [isLoading]="isRequirementsLoading()"
            [hasError]="hasRequirementsError()"
            [autoSelectFirstTodo]="!hasWorkspaceChildRoute()"
            (requirementSelected)="openRequirementIntake($event)"
          ></comp-requirement-tree>
        </div>
      </div>
    </article>
    <article class="ul-card requirement-intake-panel requirement-list-panel">
      <button type="button" class="header-button" (click)="openSelfDeclaration()">
        <div class="card-header">
          <div class="headline">
            <h2 translate="selfDeclaration.title"></h2>
          </div>
        </div>
      </button>
    </article>
  </section>

  <article
    [class.ul-card]="!hasWorkspaceChildRoute()"
    class="requirement-intake-panel requirement-workspace-panel"
    [class.scroll-shadow-top]="showFormTopShadow()"
    [class.scroll-shadow-bottom]="showFormBottomShadow()"
  >
    <div
      class="requirement-workspace-scroll"
      [class.self-declaration]="hasWorkspaceChildRoute()"
      #workspacePanel
      (scroll)="onWorkspaceScroll()"
    >
      @if (hasWorkspaceChildRoute()) {
        <router-outlet></router-outlet>
      } @else {
        <comp-requirements-detail
          [requirement]="selectedRequirement()"
          [isLoading]="isRequirementsLoading()"
          [hasError]="hasRequirementsError()"
          [isSubmitPending]="isSubmitPending()"
          [actionMessage]="actionMessage()"
          (applicabilityConfirmed)="onApplicabilityConfirmed($event)"
          (verdictSaveRequested)="saveVerdict($event)"
          (notifyReloadNeeded)="reloadRequirementIntake($event)"
        ></comp-requirements-detail>
      }
    </div>
  </article>
</section>
